import React, { memo, PropsWithChildren } from 'react';
import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import Heading from '@/shared/Heading';
import CTAs from './CTAs';
import Picture from '@/shared/Picture';
import Link from '@/shared/Link';
import withContentFlags from '@/hoc/withContentFlags';

export interface SingleImagesBannerProps {
  title: string;
  subTitle: string;
  ctas: any[];
  desktopImage: {
    src: string;
    data: {
      attributes: {
        width: number;
        height: number;
        alternativeText: string;
      };
    };
  };
  mobileImage: {
    src: string;
    data: {
      attributes: {
        width: number;
        height: number;
        alternativeText: string;
      };
    };
  };
  href: string | null;
}

const Wrapper = ({ href, children }: PropsWithChildren<{ href: string | null }>) => {
  const className = 'bg-cs-secondary relative';
  return href ? (
    <Link href={href} className={className}>
      {children}
    </Link>
  ) : (
    <Div className={className}>{children}</Div>
  );
};

const SingleImagesBanner = (props: SingleImagesBannerProps) => {
  const { title, subTitle, ctas, desktopImage, mobileImage, href } = props;

  return (
    <Wrapper href={href}>
      <Div className="grid gap-s2 md:gap-s3 justify-center text-center absolute top-s8 md:top-16 left-0 right-0">
        <Heading level="1" className="text-h-1 md:text-desktop-display">
          {title}
        </Heading>
        <Paragraph className="text-body-xl md:text-body-2xl text-cm-primary">{subTitle}</Paragraph>
        {href ? null : (
          <CTAs
            list={ctas || []}
            dataTestId="single-images-banner"
            mapClassName="flex justify-center gap-s3"
            className="py-s4 px-s6 mt-s3 !rounded-3xl"
          />
        )}
      </Div>
      <Picture
        mobile={mobileImage.data.attributes}
        desktop={desktopImage.data.attributes}
        className="w-full h-full"
        caption={title}
      />
    </Wrapper>
  );
};

export default withContentFlags(memo(SingleImagesBanner));
